import { createRouter, createWebHashHistory, RouteRecordRaw, createWebHistory } from "vue-router";
import store from "@/store";
import { Mutations, Actions, Menu, Users } from "@/store/enums/StoreEnums";
import { CookieComponent } from "@/assets/ts/components";
import {
  setCurrentPageBreadcrumbs,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import JwtService from "@/core/services/JwtService";
import { formatUserMenu } from "@/utils/userMenuUtil";
import { menu, route } from "@/core/types";
import { getIFramePath, getIFrameUrl } from "@/utils/iframe";
import { App } from "vue";
const defaultRoutes: Array<RouteRecordRaw> = [  
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
      },      
    ],
  },

  {
    path: "/",
    component: () => import("@/layout/AppLayout.vue"),
    children: [
      {
        path: "/teller",
        name: "teller",
        component: () => import("@/views/teller/Default.vue"),
        meta: {
          pageTitle: "Giao dịch viên",
        },
      },
      {
        path: "/boothCount",
        name: "boothCount",
        component: () => import("@/views/QMS/BoothCount.vue"),
        meta: {
          pageTitle: "Quầy làm việc",
        },
      },
      {
        path: "/boothLogin",
        name: "boothLogin",
        component: () => import("@/views/QMS/BoothLogin.vue"),
        meta: {
          pageTitle: "Đăng nhập",
        },
      },
      {
        path: "/boothInfo",
        name: "boothInfo",
        component: () => import("@/views/QMS/BoothInfo.vue"),
        meta: {
          pageTitle: "Thông tin quầy",
        },
      },
      {
        path: "/serviceReview",
        name: "serviceReview",
        component: () => import("@/views/QMS/ServiceReview.vue"),
        meta: {
          pageTitle: "Quầy làm việc",
        },
      },

    ],
  },
  
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () =>
          import("@/views/examples/authentication/basic-flow/SignIn.vue"),
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () =>
          import(
            "@/views/examples/authentication/basic-flow/PasswordReset.vue"
          ),
      },
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/examples/authentication/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/examples/authentication/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: defaultRoutes,
});

const check = (text) => {
  return router.currentRoute.value.fullPath.includes(text);
};

router.beforeEach(async (to, from, next) => {

  // await store.dispatch(Actions.PURGE);

  await store.dispatch(Actions.VERIFY_AUTH);
  store.commit(Mutations.RESET_LAYOUT_CONFIG);
  await CookieComponent.set("system", 2, {})
  if (CookieComponent.get("system") != undefined) {
    if (JwtService.getToken()) {     

      const userInfo = JSON.parse(CookieComponent.get('userData') || '{}');

      if(userInfo && userInfo.nMaNhomQuyen == 8 && to.fullPath != '/teller'  && to.fullPath != '/boothInfo') {
        await store.dispatch(Actions.LOGOUT)
        next({ path: "/sign-in" });
      }
      else if(userInfo && userInfo.nMaNhomQuyen == 11 && to.fullPath != '/boothCount') {
        await store.dispatch(Actions.LOGOUT)
        next({ path: "/sign-in" });
      }
      
      else if(userInfo && userInfo.nMaNhomQuyen == 12 && to.fullPath != '/serviceReview') {
        await store.dispatch(Actions.LOGOUT)
        next({ path: "/sign-in" });
      }

      else if (["/sign-in", "/sign-up", "/password-reset", "/system"].includes(to.fullPath)) {
        next({ path: "/dashboard" });
      } else {
        let userName = CookieComponent.get('userName');
        await addDynamicMenuAndRoutes(userName, to, from);
        if (router.getRoutes().filter(val => val.path == to.fullPath).length > 0) {
          next()
        }
        else {
          next("/404")
        }
      }
    } else {
      if (
        !["/sign-in", "/sign-up", "/password-reset", "/system", "/boothCount", "/boothLogin", "/boothInfo"].includes(to.fullPath)
      ) {
        next({ path: "/sign-in" });
      } else {
        next()
      }
    }
  } else {
    if (["/systems"].includes(to.fullPath)) {
      next()
    } else {
      next("/systems")
    }
  }

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

/* breadcrumb */
router.afterEach((to, from, failure) => {
  if (to.fullPath.includes("dashboard")) {
    setCurrentPageTitle("Dashboard");
  } else {
    const path = to.fullPath.substring(1).split("/");
    const length = path.length;
    let pathRoot = [] as string[];
    if (length > 1)
      pathRoot = to.fullPath
        .substring(1)
        .split("/")
        .splice(0, length - 1);
    setCurrentPageBreadcrumbs(path[length - 1], pathRoot);
  }
});

function handleStaticComponent(router, dynamicRoutes) {
  for (let j = 0; j < dynamicRoutes.length; j++) {
    if (dynamicRoutes[j].name == 'Code generation') {
      dynamicRoutes[j].component = {} as Generator;
      break
    }
  }
  router.options.routes[0].children = router.options.routes[0].children.concat(dynamicRoutes)
}

function handleIFrameUrl(path) {
  //Nested pages, save iframeUrl to store for IFrame component to read and display
  let url = path;
  let length = store.state.iframe.iframeUrls.length;
  for (let i = 0; i < length; i++) {
    let iframe = store.state.iframe.iframeUrls[i];
    if (path != null && path.endsWith(iframe.path)) {
      url = iframe.url;
      store.commit('setIFrameUrl', url);
      break
    }
  }
}

async function routerInit(app: App) {
  try {
    let userName = CookieComponent.get('userName');
    await store.dispatch(Actions.VERIFY_AUTH);
    await addDynamicMenuAndRoutes(userName, {}, {});
    app.use(router);
  } catch (error) {
    console.error("Tìm kiếm menu thất bại: ", error);
  }
}
async function addDynamicMenuAndRoutes(userName, to, from) {
  await handleIFrameUrl(to.path);
  if (store.state.app.menuRouteLoaded || !JwtService.getToken()) {
    return;
  }
  try {
    let system = CookieComponent.get("system")
    await store.dispatch(Menu.findNavTree, parseInt(system as string)).then(async res => {
      const data = res.data;
      await localStorage.removeItem("MainMenuConfig");
      localStorage.setItem(
        "MainMenuConfig",
        JSON.stringify(
          formatUserMenu(data, CookieComponent.get("userTypeId"))
        )
      );
      let dynamicRoutes = addDynamicRoutes(res.data);
      handleStaticComponent(router, dynamicRoutes);
      await router.addRoute(router.options.routes[0]);
      store.commit('menuRouteLoaded', true);
      await store.dispatch(Users.findUserPermissions, { 'name': userName }).then(res => {
        if (res.code == 200 && res.data){
          store.dispatch(Actions.ADD_PERMS, res.data)
          CookieComponent.set("permissions", JSON.stringify(res.data), {})
        }
        else
          store.dispatch(Actions.ADD_PERMS, [])
      });
    });
  } catch (error) {
    console.error("Tạo và định hướng Menu thất bại:", error);
  }
}

function addDynamicRoutes(menuList: Array<menu> = [], routes: Array<route> = []) {
  var temp: Array<menu> = [];
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].children && menuList[i].children.length >= 1) {
      temp = temp.concat(menuList[i].children)
    } else if (menuList[i].cUrl && /\S/.test(menuList[i].cUrl as string)) {
      menuList[i].cUrl = menuList[i].cUrl?.replace(/^\//, '') as string;
      // Create routing configuration
      var route: route = {
        path: menuList[i].cUrl,
        component: null,
        name: (menuList[i].cTenChucNang as string) /* + (menuList[i].url as string) */,
        meta: {
          icon: menuList[i].cIcon,
          index: menuList[i].nMaChucNang,
          title: menuList[i].cTenChucNang
        }
      };
      let path = getIFramePath(menuList[i].cUrl);
      if (path) {
        // If it is a nested page, it is displayed by iframe
        route['path'] = path;
        route['component'] = (() => import(`@/views/IFrame/IFrame.vue`));
        // Store nested page routing paths and access URLs

        let url = getIFrameUrl(menuList[i].cUrl);
        let iFrameUrl = { 'path': path, 'url': url };
        store.commit('addIFrameUrl', iFrameUrl)
      } else {
        try {

          let array: string[] = menuList[i].cUrl?.split('/') as Array<string>;
          let url: string = '';
          for (let i = 0; i < array.length; i++) {
            url += array[i].substring(0, 1).toUpperCase() + array[i].substring(1) + '/'
          }
          url = url.substring(0, url.length - 1);

          route.component = (async () => await import(`@/views/${url}`))
          /* route.path = "/" + url.toLowerCase() */
        } catch (e) {
        }
      }
      routes.push(route)
    }
  }
  if (temp.length >= 1) {
    addDynamicRoutes(temp, routes)
  } else {
  }
  return routes
}

export default router;
export { routerInit }

